module.exports = __webpack_public_path__ + "img/bg.d9d6f9a9.jpg";